import { render, staticRenderFns } from "./PricingCard.vue?vue&type=template&id=a7ed9a80&scoped=true"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"
import style0 from "./PricingCard.vue?vue&type=style&index=0&id=a7ed9a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ed9a80",
  null
  
)

export default component.exports